import React, { use } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { LotDetailContext } from "../../../../../Contexts/LotDetailContext";

export function PackageCountFields() {
    const { t } = useTranslation();
    const {
        lotDetail: {
            summary: {
                data: {
                    packageCount
                }
            }
        },
    } = use(LotDetailContext);

    return (
        <Form.Group as={Col} sm={6} controlId="formPackageCount">
            <Row>
                <Form.Label column sm={4}>{t('LotDetails.Summary.PackageCount')}:</Form.Label>
                <Col sm={8}>
                    <Form.Control type="text" disabled value={packageCount ?? ""} />
                </Col>
            </Row>
        </Form.Group>
    );
}